import styled from '@emotion/styled';

import Form from 'components/form/Form';

export const CardItem = styled.button`
	display: flex;
	border: 1px solid var(--border-color);
	border-radius: 0.5rem;
	align-items: center;
	flex-wrap: wrap;
	padding: 1rem;
	width: 100%;
	height: 5rem;
	background-color: var(--white);
	cursor: pointer;

	:hover {
		background-color: var(--background-3);
	}
`;

export const Badge = styled.div`
	align-self: center;
	margin: 0 2rem;
	background: var(--textButtonBgColor);
	padding: 0.5rem;
	border-radius: 0.5rem;
`;

export const StyledForm = styled(Form)`
	justify-content: center;
	gap: 1.5rem;
`;
